import { ShoppingCartPartialStoreState, SHOPPING_CART_STATE_KEY } from './shopping-cart.reducer';

export const getShopingCart = (state: ShoppingCartPartialStoreState) =>
    state[SHOPPING_CART_STATE_KEY];

export const getTicketPayloadsPosted = (state: ShoppingCartPartialStoreState) =>
    state[SHOPPING_CART_STATE_KEY].ticketPayloadsPosted;

export const getDocNums = (state: ShoppingCartPartialStoreState) =>
    state[SHOPPING_CART_STATE_KEY].docNums;

export const getTicketsGrouped = (state: ShoppingCartPartialStoreState) =>
    state[SHOPPING_CART_STATE_KEY].ticketsGrouped;

export const getTicketsGroupedUids = ( state: ShoppingCartPartialStoreState ) =>
    state[SHOPPING_CART_STATE_KEY].ticketsGroupedUids;

export const getShoppingCartTickets = (state: ShoppingCartPartialStoreState) =>
    state[SHOPPING_CART_STATE_KEY].ticketsByDocNum;

export const getTermsAgreed = ( state: ShoppingCartPartialStoreState ) =>
    state[ SHOPPING_CART_STATE_KEY ].termsAgreed;

export const failedTickets = (state: ShoppingCartPartialStoreState) =>
    state[SHOPPING_CART_STATE_KEY].failedTickets;
